import { FC } from 'react';
import { Tooltip } from 'antd';
import { WarningOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import { useTranslation } from '@packages/utils';
import { TParticipationColumnProps } from './ParticipationColumn.types';
import {
  Cell,
  NearText,
  OverText,
  MutedText,
} from './ParticipationColumn.styles';

const CAPACITY_EMPTY_TEXTS = [
  'UNLIMITED_LONG',
  'UNLIMITED_SHORT',
  'LIMITED_WITH_EVENT',
  'LIMITED_WITH_WORKSHOP',
];

const ParticipationColumn: FC<TParticipationColumnProps> = ({
  registrantCount,
  capacity,
  capacityKeyPrefix,
  attendanceCount,
  hasWaitList,
  isPlanning,
  atCapacityTooltip,
  nearCapacityTooltip,
}) => {
  const { t: tCapacity } = useTranslation({ keyPrefix: capacityKeyPrefix });
  const capacityText =
    capacity && CAPACITY_EMPTY_TEXTS.includes(capacity)
      ? tCapacity(capacity)
      : capacity ?? '';
  if (isPlanning) {
    return (
      <Cell>
        <MutedText>-- / -- / --</MutedText>
      </Cell>
    );
  }

  const numericCapacity = capacity !== null ? Number(capacity) : null;
  const values = `${capacityText} / ${registrantCount} / ${attendanceCount}`;

  const isOverCapacity = hasWaitList;
  const isNearCapacity =
    !isOverCapacity &&
    numericCapacity !== null &&
    numericCapacity > 0 &&
    registrantCount * 5 >= numericCapacity * 4 &&
    registrantCount <= numericCapacity;

  if (isOverCapacity) {
    return (
      <Tooltip title={atCapacityTooltip}>
        <Cell>
          <ExclamationCircleFilled style={{ color: '#c0392b' }} />
          <OverText>{values}</OverText>
        </Cell>
      </Tooltip>
    );
  }

  if (isNearCapacity) {
    return (
      <Tooltip title={nearCapacityTooltip}>
        <Cell>
          <WarningOutlined style={{ color: '#b26b00' }} />
          <NearText>{values}</NearText>
        </Cell>
      </Tooltip>
    );
  }

  return <Cell>{values}</Cell>;
};

export default ParticipationColumn;
